import React, { useState } from 'react';
import MiniUnitCard from './MiniUnitCard';
import ImageUploader from './ImageUploader';
import styles from '../../styles/Building MGMT/BuildingEdit.module.css';

const BuildingEdit = ({ initialBuilding, onSave }) => {
  const [building, setBuilding] = useState(initialBuilding);
  const [images, setImages] = useState([]);
  const [keyImage, setKeyImage] = useState(null);


  const handleDescriptionChange = (e) => {
    setBuilding({ ...building, Description: e.target.value });
  };

	const handleAmenityToggle = (amenity) => {
	  setBuilding(prev => ({
		...prev,
		Amenities: prev.Amenities.includes(amenity)
		  ? prev.Amenities.filter(a => a !== amenity)
		  : [...prev.Amenities, amenity],
	  }));
	};

  return (
    <div className={styles.editContainer}>
      <div className={styles.unitsSection}>
        <h2>Units in Building</h2>
        <div className={styles.unitsList}>
          {building.units.map((unit) => (
            <MiniUnitCard key={unit.id} unit={unit} />
          ))}
          <button className={styles.addUnitBtn}>➕ Add Unit</button>
        </div>
      </div>
	  
	  <hr className={styles.sectionDivider} />

      <div className={styles.buildingDetails}>
		<div className={styles.buildingImages}>
		  <ImageUploader
			images={images}
			setImages={setImages}
			keyImage={keyImage}
			setKeyImage={setKeyImage}
		  />
		</div>

        <div className={styles.descriptionAmenities}>
		<div className={styles.totalUnits}>
		  Total Units in Building:
		  <input
			type="number"
			min={building.units.length}
			value={building.TotalUnits}
			onChange={(e) =>
			  setBuilding({
				...building,
				TotalUnits: Math.max(building.units.length, Number(e.target.value)),
			  })
			}
			className={styles.totalUnitsInput}
		  />
		</div>


          <div className={styles.description}>
            <label>Building Description</label>
            <textarea
              value={building.Description}
              onChange={handleDescriptionChange}
            />
          </div>

		<div className={styles.amenityGrid}>
		  {["Gym", "Pool", "Parking", "Pet-Friendly", "Elevator", "Laundry", "Wi-Fi"].map((amenity) => (
			<div
			  key={amenity}
			  className={`${styles.amenityItem} ${
				building.Amenities.includes(amenity) ? styles.selected : ''
			  }`}
			  onClick={() => handleAmenityToggle(amenity)}
			>
			  {amenity}
			</div>
		  ))}
		</div>


        </div>
      </div>

      <button className={styles.saveBtn} onClick={() => onSave(building)}>Save Changes</button>
    </div>
  );
};

export default BuildingEdit;
